<template>
  <div class="cart-recommend-item">
    
    <div class="is-flex justify-content-between">
      <div class="cart-recommend-item-left body-text-dark has-text-dark">
        <h3 class="is-size-16 has-text-weight-semibold pointer" @click.prevent="callback(item)">{{ item.name }}</h3>
        <p class="is-size-11 has-text-weight-semibold is-uppercase mt10 letter-space-1"><span  v-if="item.brand.name && (item.brand.name != 'No Brand')"><em class="has-text-grey font-style-normal">{{ item.brand.name }}</em></span>  <span class="text-primary" v-if="item.cannabis_attributes && item.cannabis_attributes.plant_type"> <span v-if="item.brand && item.brand.name && (item.brand.name != 'No Brand')">&nbsp;|&nbsp;</span> {{ item.cannabis_attributes.plant_type }}</span></p>
        <div class="recommend-product-attrs is-flex">
          <div class="recommend-product-img pointer mr10" @click.prevent="callback(item)">
            <img v-if="item.image" :src="item.image+'?d=200x200'" :alt="item.name" />
            <img v-else src="@/assets/img/leaf.png" :alt="item.name" />
          </div>
          <div class="recommend-product-thc-cbd">
            <div class="product-weed-right" v-if="item.product_family == 'cannabis'">
              <div class="weed-thc-level">
                  <div v-if="item.thc_cbd_levels && thc">
                    <p class="is-size-10px">THC</p>
                    <p class="is-size-12px has-text-weight-semibold">{{ thc }}</p>
                    <div :class="'weed-thc-indicator ' + (item.thc_cbd_levels ? item.thc_cbd_levels.thc_level : '')"><span></span><span></span><span></span></div>
                  </div>
                </div>
                <div class="weed-cbd-level is-flex-column is-flex">
                  <div v-if="item.thc_cbd_levels && cbd">
                    <p class="is-size-10px">CBD</p>
                    <p class="is-size-12px has-text-weight-semibold">{{ cbd }}</p>
                    <div :class="'weed-thc-indicator ' + (item.thc_cbd_levels ? item.thc_cbd_levels.cbd_level : '')"><span></span><span></span><span></span></div>
                  </div>
                </div>
            </div>
          </div>
        </div>
      </div>
      <div class="cart-recommend-item-right">
        <ul class="recommend-item-variants" v-if="variants.length > 0">
          <li @click.prevent="addToCart(variant)" class="has-text-right pointer recommend-item-variant" :id="'recomment_variants' + variant.id" v-bind:key="'recomment_variants' + variant.id " v-for="variant in variants">
            <span class="size is-size-14 is-block">{{ variant.size }}</span>
            <span class="price is-size-16 is-block has-text-weight-semibold">${{ variantPrice(variant) }}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import Helpers from '@/Components/Helpers/Helpers';
import Env from "@/env";
import CartApis from '@/Components/Controllers/CartApis';
import VboutApis from '@/Components/Controllers/VboutApis';
import ProductApis from '@/Components/Controllers/ProductApis';
import { mapGetters, mapActions} from 'vuex';

export default {
  props: {
    item: {
      required: true,
      type: Object
    },
    callback: {
      required: true,
      type: Function
    },
  },
  name: 'CartRecommendProductItem',
  data() {
    return {
     qty: 1,
    };
  },
  computed: {
    
    ...mapGetters({
      vg_cartId: "cart/id",
      vg_businessProfile: "businessprofile/detail", 
      vg_cartItems: "cart/cartItems",
      vg_selectedStore: "location/selected",
      vg_cannabisLimit: "location/cannabis_limit",
      vg_is_greenline_pos: "location/is_greenline_pos",
      vg_cartSubTotal: "cart/cartSubTotal",
      vg_cartTax: "cart/cartTax",
      vg_newSubTotal: "cart/newSubTotal",
      vg_greenlineProductDeposit: "cart/greenline_product_deposit",
      vg_cartPromoCode: "cart/promocode",
      vg_cartLoyality: "cart/loyality",
      vg_cartGrandTotal: "cart/cartGrandTotal",
      vg_weightOnCart: "cart/cartWeight",
      vg_guestLandedQueries: "location/guestLandedQueries",
      vg_cartLoyalityPointsObj: "cart/loyalityPointsObj",
      vg_userLoyalitySubscription: "userloyalitysubscription/subscribed",
      vg_userLoyalitySubscriptionObj: "userloyalitysubscription/obj",
      vg_userId: "getLoggedInUserId",
      vg_loggedInUser: "getLoggedInUser",
      vg_hasBusinessLoyalityProgram: "businessprofile/hasBusinessLoyalityProgram",
      vg_businessLoyalityProgram: "businessprofile/businessLoyality",
      vg_checkoutOrderType: "checkout/ordertype",
    }),

    variants() {
      // First create unique variant , only for cannabis
      return Helpers.getUniqueProductVariants(this.item.product_family, this.item.variants);
    },
    thc() {
      return Helpers.getTHCValue(this.item);
    },
    cbd() {
      return Helpers.getCBDValue(this.item);
    },
  },

  async mounted() {
   
  },
  
  beforeDestroy() {

  },

  methods: {

    variantPrice(variant) {
      if(variant.sale_price && (variant.sale_price < variant.price)){
        return variant.sale_price.toFixed(2);
      }
      return variant.price.toFixed(2);
    },
    
    /**
     * Add to cart
     */
    async addToCart(variant) {
   
      // Fetch the product detail because the list api doesnot have full data
      this.va_spinner(true);
      // let res = await ProductApis.fetchById(this.item.id);
      // if(res.status != 200){
      // return this.va_snackbar({
      //   type: 'warning', 
      //   message: 'Sorry error getting product detail.',
      // });
      // }
      // this.productDetail = res.data.payload;

       // If we dont have cart id create cart first 
      if(this.vg_cartId == ''){
        await CartApis.createCart(this.vg_selectedStore.id, Helpers.getLocationCartFullUrl(this));
      }
  

      // If already exceed limit
      if( parseFloat(this.vg_weightOnCart) > parseFloat(this.vg_cannabisLimit) ){
        this.va_spinner(false);
        bus.$emit('show-modal-cart-limit-exceed', {
          overWeight: this.vg_weightOnCart,
          modal: true,
        });
        return false;
      }
     
      // If going to exceed limit on adding this item
      let currentProductWeight = this.qty * parseFloat(variant.weight_equivalent_dry_cannabis);
      let finalWeight = parseFloat(currentProductWeight) + parseFloat(this.vg_weightOnCart);
    
      if(finalWeight > parseFloat(this.vg_cannabisLimit) ) {
        this.va_spinner(false);
        bus.$emit('show-modal-cart-limit-exceed', {
          overWeight: finalWeight,
          modal: true,
        });
        return false;
      }

      let checkExistingProduct = _.find(this.vg_cartItems, { location_product_id: parseInt(this.item.id), location_product_variant_id: parseInt(variant.id) });
 
      if(checkExistingProduct == undefined){
        // validate if we have instock
        if(parseInt(this.qty) > variant.no_of_units){
          // reject cannot add qty more than no of units
          this.va_spinner(false);
          return this.va_snackbar({
            message:  Env.errorMessages.exceed_stock_limit,
            type: 'error',
          });
        } 
        await this.addCartItem(variant);
        // once added item add calss to to so that we can fade out
        document.getElementById('recomment_variants'+variant.id).classList.add("added")
        this.va_spinner(false);
      } else {
        // Now before update lets check no of qty he can add
        let existingProductQty = checkExistingProduct.unit;
        let maxCanBeAdded = parseInt(variant.no_of_units) - parseInt(existingProductQty);
        if(parseInt(this.qty) > maxCanBeAdded){
          // reject cannot add qty more than no of units
          this.va_spinner(false);
          return this.va_snackbar({
            message: Env.errorMessages.exceed_stock_limit,
            type: 'error',
          });
        } 
        await this.updateCartItem(checkExistingProduct);
      }
    },

    /**
     * Add cart item
     */
    async addCartItem(variant) {
      let obj = {
        user_id: this.$store.getters.getLoggedInUserId,
        location_id: this.vg_selectedStore.id,
        cart_id: this.vg_cartId == '' ? 'Not available' : this.vg_cartId,
        location_product_id: this.item.id,
        category_id: this.item.category_id ? this.item.category_id : null,
        category_name: this.item.category ? this.item.category.name : null,
        thc_cbd_value_type: this.item.category ? this.item.category.thc_cbd_value_type : '',
        product_name: this.item.name,
        product_family: this.item.product_family,
        product_id: this.item.id,
        product_image: this.item.image ? this.item.image : 'http://unohop.dev.unoapp.io/img/leaf.47bfc5db.png',
        product_type: this.item.product_type ? this.item.product_type : '',
        brand_name: this.item.brand ? this.item.brand.name : '',
        location_product_variant_id: variant.id,
        location_variant_sku: variant.sku,
        location_product_variant_external_sku: variant.external_id,
        price: parseFloat(variant.sale_price) > 0 && parseFloat(variant.sale_price) < parseFloat(variant.price) ? variant.sale_price : variant.price, // if has sale price & sale must be lower than regular, then use sale else regular price
        actual_price: variant.price,
        weight: variant.weight_equivalent_dry_cannabis ? variant.weight_equivalent_dry_cannabis : 0,
        unit: 1,
        app_version: Env.appVersion,
        platform: Env.appPlatform,
        //product: this.productDetail, // triple to match fav style
        selected_variant: variant,        
        weighing_unit: this.item.weighing_unit ? this.item.weighing_unit : 'null',
      }

      // Add THC,CBD,cannabis attributes only if family is cannabis
      if(this.item.product_family == 'cannabis'){
        obj.cannabis_attributes = this.item.cannabis_attributes ? Helpers.unsetKeyFromObj(['createdAt', 'updatedAt', 'created_at', 'updated_at'], this.item.cannabis_attributes) : {};
        obj.thc_cbd_levels = this.item.thc_cbd_levels ? Helpers.unsetKeyFromObj(['created_by', 'createdAt', 'updated_by', 'updatedAt', 'created_at', 'updated_at'], this.item.thc_cbd_levels) : {};
      }

      let res = await CartApis.add(obj, this);
      if(res.status == 200) {
       
       // when item is added on recommend product pass it to added item
        bus.$emit('added-to-cart-recommend-product-added', obj)

        // we get cart id here assign it
        this.va_setCartId(res.data.payload.id);
        this.va_setCartDetail(res.data.payload);
        if(this.$store.getters.getLoggedInUserId == false){
          // If guest user 
          this.va_snackbar({
            message:  res.data.msg,
            type: 'success',
          });
        } else {
          // Description is not allowed on add to cart so add once its done for vbout
          //  obj.description = this.productDetail.description; not any more
          // lets save the data on vbout
          VboutApis.addCartItem(obj, Helpers.getLocationProductFullUrl(this, obj.product_id), this.vg_selectedStore.id);
        }
       
        // G tracking add to cart
        this.$gtag.event('add_to_cart', { 
          items: [
            {
              id: this.item.id,
              name: this.item.name, 
              brand: this.item.brand ? this.item.brand.name : null,
              category: this.item.category ? this.item.category.name : null,
              variant: variant.size ? variant.size : null,
              quantity: parseInt(this.qty),
              price: parseFloat(variant.sale_price) > 0 && parseFloat(variant.sale_price) < parseFloat(variant.price) ? variant.sale_price : variant.price,
            }
          ]
        });
        return obj;
      }
  
      this.va_snackbar({
        message: res.status == 200 ? res.data.msg : res.response.data.payload[0],
        type: res.status == 200 ? 'success' : 'error',
      });
      return false;
 
    },

     /**
     * Update cart item
     */
    async updateCartItem(item) {
      this.va_spinner(true);
      //Clone the object and filter
      var obj = _.clone(item);
      obj.cart_item_id = item.id;
      obj.unit = parseInt(item.unit) + parseInt(1);
      obj.app_version = Env.appVersion;
      obj.platform = Env.appPlatform;
      let res = await CartApis.update(obj);
      this.va_spinner(false);
      if(res.status == 200) {
        if(this.$store.getters.getLoggedInUserId == false){
          // If guest user 
          this.va_snackbar({
            message: res.data.msg,
            type: 'success',
          });
        } else {
         // For vbout only push current added because its add api not update api
          obj.unit = parseInt(this.qty);
          VboutApis.addCartItem(obj, Helpers.getLocationProductFullUrl(this, obj.product_id), this.vg_selectedStore.id);
        }
        return true;
      } 
      this.va_snackbar({
        message: res.status == 200 ? res.data.msg : res.response.data.payload[0],
        type: res.response.status == 200 ? 'success' : 'error',
      });
      return false;
    },

    ...mapActions({
      va_spinner: "spinner/setSpinner",
      va_snackbar: "snackbar/setSnackbar",
      va_setCartId: "cart/setId",
      va_setCartDetail: "cart/setCartDetail",
    })

  },
};
</script>

